export const getExamConfigQuery = /* GraphQL */ `
  query GetExamConfig($input: ModelGetInput!) {
    getExamConfig(input: $input) {
      id
      sk
      schemaVersion
      idInc
      idVendor
      maturity
      type
      version
      resourceId
      bankId
      workspaceId
      name
      description
      appId
      appKey
      config
      creatorId
      creator {
        id
        email
        firstName
        lastName
      }
      tags {
        key
        type
        value
      }
      workspace {
        id
        sk
        name
        tags {
          key
          type
          value
        }
      }
    }
  }
`;

/** @deprecated */
export const getExamConfigQueryLegacy = /* GraphQL */ `
  query GetExamConfig($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      idInc
      name
      appId
      maturity
      config
      alignments {
        items {
          id
          sk
          content
          abbreviation
          scope
        }
      }
      resource {
        id
        sk
        name
        description
        createdAt
        creatorId
        grade
        difficulty
        questions {
          id
          sk
          name
          idInc
          fontScaling
          content {
            canvas {
              content
              scoring
              config
            }
          }
        }
        content {
          forms {
            sections {
              questionIds
            }
          }
        }
        workspaceId
        workspace {
          id
          name
        }
      }
      workspaceId
      createdAt
      updatedAt
      tags {
        key
        type
        value
      }
    }
  }
`;

/** @deprecated used once in a CLI command */
export const getExamConfigQueryLegacy2 = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      schemaVersion
      idInc
      idVendor
      type
      version
      resourceId
      bankId
      workspaceId
      name
      description
      resource {
        content {
          forms {
            sections {
              name
              questionIds
            }
          }
        }
        questions {
          id
          sk
          name
          alignments {
            items {
              id
              abbreviation
              content
              scope
            }
          }
          content {
            canvas {
              id
              type
              interactionType
              content
              config
              scoring
            }
          }
          contexts {
            items {
              id
              sk
              name
              type
              content {
                body
              }
            }
          }
        }
      }
    }
  }
`;
